// extracted by mini-css-extract-plugin
export default {"link":"styles_link__X1O7M","linkTitle":"styles_linkTitle__6KoEG","linkImage":"styles_linkImage__bnJg7","linkDecoration":"styles_linkDecoration__IyVyf"};